const nameValidate = value => {
  //logic for validate name
  const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

  return nameRegex.test(value);
};

const emailValidate = value => {
  //logic for validate email
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value);
};

const passwordValidate = value => {
  //logic for password validate
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d+)(?=.*[#$^`+=!*()~{}\'\"\[\]|@%&_,\-./:;<>?]).{8,30}$/;
  return passwordRegex.test(value);
};

export { nameValidate, emailValidate, passwordValidate };
